module.exports = __webpack_public_path__ + "static/media/Mock-Up-Application.1c3656a1.webp";